<template>
  <div>
    <el-dialog
      title="查看发货信息"
      :visible.sync="isShow"
      width="1000px"
      class="partShipment"
      @close="closeDialog"
    >
      <span slot="title">
        查看发货信息 (<span style="color: red;"> {{ tableData.strategyShipmentInfo?.deliveryNum }} </span>)
      </span>
      <div>
        <span>产品信息</span>
        <el-table v-isLoading="isLoading" :data="tableData?.strategyShipmentProductList" border style="width: 100%;margin-top: 5px;" show-summary :summary-method="getSummaries">
          <el-table-column type="index" width="70" label="序号" align="left" fixed="left" />
          <el-table-column prop="materialNumber" label="物品代码" align="left" />
          <el-table-column prop="productName" label="物品名称" align="left" />
          <el-table-column prop="productNum" label="未发货数量" align="left" />
          <el-table-column prop="productPriceSigle" label="实际结算单价" align="right" header-align="left" width="160" />
          <el-table-column prop="settlementAmount" label="实际结算金额" align="right" header-align="left" width="160" />
          <el-table-column prop="expectedDeliveryDate" label="客户期望发货日" align="left">
            <template v-slot="{ row }">
              {{ row.expectedDeliveryDate.substring(0, 10) }}
            </template>
          </el-table-column>
          <el-table-column prop="agreedDate" label="约定交付日期" align="left">
            <template v-slot="{ row }">
              {{ row.agreedDate.substring(0, 10) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="information-changes">
        <div class="information">
          原信息
        </div>
        <div>
          收货地址：
          {{ tableData.primaryReceiptAddress }}
        </div>
        <div>
          <span>运输方式：{{ tableData?.primaryModelOfShipping }}</span>
          <span>承运商：{{ tableData?.primaryCarrier }}</span>
        </div>
        <div class="information">
          变更后信息
        </div>
        <div>
          变更后收货地址：
          {{ tableData.receiptAddressStr }}
        </div>
        <div>
          <span>变更后运输方式：{{ tableData?.modeOfShipping }}</span>
          <span>变更后承运商：{{ tableData?.carrier }}</span>
        </div>
        <div>
          <span>运费差价：{{ tableData?.freight }}</span>
          <span>运费支付方式：{{ tableData?.freightPayTypeStr }}</span>
        </div>
        <div>
          <span>价外费用合同号：<span style="color: #53a8ff; cursor: pointer">{{ tableData?.freightContractNum }}</span></span>
          <span>价外费用合同分配金额/比例：{{ tableData?.freightProportion }}</span>
        </div>
      </div>
      <div class="information-changes-bottom">
        <div>
          <span>唛头单号：{{ tableData?.marksNum }}</span>
          <span>授权邮箱：{{ tableData?.authorizationEmail }}</span>
        </div>
        <div>收货回执及到货验收要求：</div>
        <div>{{ tableData?.receiptArrivalAcceptanceRequirements }}</div>
        <div>回执附件：<span style="color: #53a8ff; cursor: pointer" @click="fileDownload">{{ tableData.reversedInvoiceVO?.fileName }}</span></div>
        <div>发货备注说明：</div>
        <div>{{ tableData?.deliverRemark }}</div>
        <div>备注：{{ tableData?.remark }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="closeDialog">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { querySpecialInvoiceDetail, getUrlByFileID } from '@/API';
import { getNum, numToFixed } from '@/libs/util';
import Big from 'big.js';

export default {
  data () {
    return {
      isShow: false,
      isLoading: false,
      tableData: {}
    };
  },

  methods: {
    openDialog (val) {
      this.tableData = {};
      querySpecialInvoiceDetail(val.id).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          this.tableData = data;
          this.isShow = true;
        }
      });
    },

    closeDialog () {
      this.isShow = false;
    },

    fileDownload () {
      getUrlByFileID(this.tableData.reversedInvoiceVO.fileToken).then((res) => {
        let { status, data } = res.data;
        if (status === '200') {
          window.open(data);
        }
      });
    },

    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '未发货数量') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(getNum(cur.productNum)).plus(pre).toString()), 0);
          return;
        }
        if (column.label === '实际结算金额') {
          let count = data.reduce((pre, cur) => getNum(Big(getNum(cur.settlementAmount)).plus(pre).toString()), 0);
          sums[index] = numToFixed(count, 2);
        }
      });
      return sums;
    }

  }
};
</script>
<style lang="scss" scoped>
.information-changes{
  border-bottom: 1px solid #000;
  margin-bottom: 5px;
  padding-bottom: 5px;
  .information{
    font-weight: bold;
    font-size: 20px;
  }
  div{
    padding: 8px 0;
    display: flex;
    span{
      width: 300px;
    }
  }
}
.information-changes-bottom{
  div{
    padding: 8px 0;
    display: flex;
    span{
      width: 300px;
    }
  }
}

</style>
